import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Snack_SnackEditPage_Query } from "./query";

type Props = {
	hotelID: string;
	uuid: string;
};

export const useSnackListQuery = ({ hotelID, uuid }: Props) => {
	const { data } = useCustomSuspenseQuery(Snack_SnackEditPage_Query, {
		variables: {
			hotelID,
			uuid,
		},
	});

	return {
		data,
	};
};
